import { GlobalWorkerOptions, getDocument } from "pdfjs-dist/legacy/build/pdf";

GlobalWorkerOptions.workerSrc =
  "https://cdnjs.cloudflare.com/ajax/libs/pdf.js/2.16.105/pdf.worker.min.js";

function normalizeText(input) {
  return String(input ?? "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toUpperCase();
}


function extractInvoicePrefixAndNumber(normalizedText) {
  const anchor = /FACTURA\s+ELECTRONICA\s+DE\s+VENTA/;
  const hit = anchor.exec(normalizedText);
  if (!hit) return null;

  let after = normalizedText.slice(hit.index + hit[0].length);
  after = after.replace(/^\s+/, "");

  const lines = after
    .split(/\n/)
    .map((l) => l.trim())
    .filter(Boolean);

  const strictLine = /^([A-Z0-9]{1,20})-(\d{1,20})$/;

  for (const line of lines.slice(0, 8)) {
    const exact = line.match(strictLine);
    if (exact) {
      return { prefix: exact[1], number: exact[2] };
    }
    
    const embedded = line.match(/\b([A-Z][A-Z0-9]{0,19})-(\d{1,20})\b/);
    if (embedded) {
      return { prefix: embedded[1], number: embedded[2] };
    }
  }

  return null;
}

export async function extractTextFromPdfFile(file, { maxPages = 2 } = {}) {
  const data = await file.arrayBuffer();
  const pdf = await getDocument({ data }).promise;
  const pagesToRead = Math.min(pdf.numPages, Math.max(1, maxPages));

  const parts = [];
  for (let i = 1; i <= pagesToRead; i += 1) {
    const page = await pdf.getPage(i);
    const content = await page.getTextContent();
    for (const item of content.items || []) {
      if (item?.str) parts.push(item.str);
    }
  }
  return parts.join("\n");
}

export function isInvoiceImageFile(file) {
  const t = file.type || "";
  const n = file.name || "";
  if (/^image\/(jpeg|png|webp|gif)$/i.test(t)) return true;
  return /\.(jpe?g|png|webp|gif)$/i.test(n);
}

/** Valida PDF (texto extraíble) o acepta imagen de factura sin OCR. */
export async function validateInvoiceFile(file) {
  if (!file) return { ok: false, reasons: ["No se encontró archivo"] };
  if (isInvoiceImageFile(file)) {
    return {
      ok: true,
      reasons: [],
      meta: {
        isImage: true,
        hasNumbering: false,
        invoiceId: null,
        sample: "",
      },
    };
  }
  return validateInvoicePdf(file);
}

export async function validateInvoicePdf(file) {
  if (!file) return { ok: false, reasons: ["No se encontró archivo"] };

  const isPdf =
    file.type === "application/pdf" || /\.pdf$/i.test(file.name || "");
  if (!isPdf) {
    return {
      ok: false,
      reasons: ["El archivo debe ser un PDF o una imagen (JPG, PNG, WEBP, GIF)"],
    };
  }

  let text = "";
  try {
    text = await extractTextFromPdfFile(file, { maxPages: 2 });
  } catch (e) {
    return {
      ok: false,
      reasons: ["No pudimos leer el PDF. Verifica que no esté protegido/dañado."],
    };
  }

  const t = normalizeText(text);
  const invoiceId = extractInvoicePrefixAndNumber(t);

  const requiredAny = [
    /FACTURA\s+ELECTRONICA\s+DE\s+VENTA/,
    /FACTURA\s+ELECTRONICA/,
  ];
  const requiredAll = [
    /\bNIT\b/,
    /\bCUFE\b/,
  ];

  const missing = [];
  if (!requiredAny.some((re) => re.test(t))) {
    missing.push("La factura electrónica no pudo ser identificada, no se encontró el marcador 'FACTURA ELECTRÓNICA'.");
  }
  for (const re of requiredAll) {
    if (!re.test(t)) {
      missing.push(`Falta el campo ${String(re).replaceAll("/", "")}`);
    }
  }

  if (!invoiceId) {
    missing.push(
      "No se pudo identificar el prefijo y número bajo 'FACTURA ELECTRÓNICA DE VENTA' (ej. T359-8602 o SETT-80166)."
    );
  }

  const hasNumbering = /AUTORIZACION\s+NUMERACION|NUMERACION\s+DE\s+FACTURACION/.test(t);
  if (!hasNumbering) {
  }

  console.log("missing:", missing);
  console.log("invoiceId:", invoiceId);
  console.log("hasNumbering:", hasNumbering);
  console.log("t:", t);

  return {
    ok: missing.length === 0,
    reasons: missing,
    meta: {
      hasNumbering,
      invoiceId,
      sample: t.slice(0, 500),
    },
  };
}

